import { Injectable, inject } from '@angular/core'
import { Filter, RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Vendor } from '../vendor'
import { environment } from '../../../../environments/environment'

export class VendorFilter {
  public static ids(ids: string[]): Filter {
    return new Filter('ids', ids)
  }

  public static vendorName(name: string): Filter {
    return new Filter('name', name)
  }
}

@Injectable({
  providedIn: 'root',
})
export class VendorService extends RestClientPaged<Vendor, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/vendors', http, {
      idField: 'id',
    })
  }
}
